<template>
    <b-table :fields="fields" :items="items" class="m-0" small/>
</template>

<script>
import _ from "lodash"
import numbers, {price} from "../../../helpers/numbers";

export default {
    props: {
        promotionLines: {required: true, type: Array},
        salesOrderLine: {required: true, type: Array},
        dispatchRequestLine: {required: true, type: Array},
    },

    computed: {
        uniqueMetadataKeys() {
            return _.chain(this.promotionLines)
                .map(line => Object.keys(line.metadata))
                .flatten()
                .uniq()
                .value()
        },
        fields() {
            return [
                {
                    key: 'identifier',
                    label: 'Code',
                },
                {
                    key: 'display_name',
                    label: 'Naam',
                },
                {
                    key: 'promotion_line_amount',
                    label: 'Bedrag',
                    formatter: numbers.price
                },
            ].concat(this.uniqueMetadataKeys)
        },
        items() {
            return this.promotionLines.map(line => {
                _.each(line.metadata, (value, key) => {
                    line[key] = value
                })
                line.promotion_line_amount = line.promotion_amount / this.salesOrderLine.quantity * this.dispatchRequestLine.quantity
                return line
            })
        },
    }
}
</script>

<style scoped>

</style>
